<template>
    <NavBar color="black" :ellipsis="false"></NavBar>
    <div class="renzheng-box" v-if="! timer">
        <img class="icon-rz" src="@/assets/images/icon-rz.png" alt="" />
        <div class="rz1">填写领奖信息</div>
        <div class="input-wrapper" v-if="welfare.receiver_name_need">
            <input class="input-name" placeholder="填写联系人姓名" v-model="welfare.receiver_name"/>
        </div>
        <img
            class="line-1 input-line"
            src="@/assets/images/input-line.png"
            alt=""
            v-if="welfare.receiver_name_need"
        />
        <div class="input-wrapper">
            <input class="input-idcard" placeholder="填写联系电话" type="text" v-model="welfare.receiver_mobile"/>
        </div>
        <img
            class="input-line"
            src="@/assets/images/input-line.png"
            alt=""
        />
        <div class="input-wrapper" v-if="welfare.receiver_address_need">
            <textarea class="input-idcard" placeholder="填写收货地址" type="text" v-model="welfare.receiver_address"></textarea>
        </div>
        <img
            class="input-line"
            src="@/assets/images/input-line.png"
            alt=""
            v-if="welfare.receiver_address_need"
        />
        <div class="shenfen-text-content" v-if="welfare.receiver_address_need">*收货地址用于奖品邮寄，请谨慎填写，建议填写格式：××省-××市-××区-详细收件地址</div>
        <div class="shenfen-text-title">信息受到保护</div>
        <div class="btn-renzheng" @click="check">提交</div>
        <div class="confirm" v-show="confirm">
            <p class="subtitle">您填写完地址后，将不可以心意投递给其他用户。</p>
            <div class="button-box">
                <div class="button close" @click="confirm = false">再想想</div>
                <div class="button" @click="submit">确认</div>
            </div>
        </div>
    </div>
    <div class="renzheng-box" v-else>
        <img class="icon-rz" src="@/assets/images/icon-rz.png" alt="" />
        <p class="rz1">信息提交成功</p>
        <p class="subtitle">即将返回</p>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>